import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import "./style.css";
import TeacherWalletSummary from "./components";
import { getTeachers } from "../../services/auth";

const TeacherTransactions = () => {
  const [selectedTeacherId, setselectedTeacherId] = useState("");
  const [selectedMonth, setSelectedMonth] = useState();
  const [searchParams, setSearchParams] = useState({
    teacherId: "",
    month: "",
  });

  const [displayName, setDisplayName] = useState("");
  const [teachers, setteachers] = useState([]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (selectedTeacherId && selectedMonth) {
      setSearchParams({ teacherId: selectedTeacherId, month: selectedMonth });
    }
  };

  const handleChange = (e) => {
    const teacherId = e.target.value;
    setselectedTeacherId(teacherId);

    if (teacherId) {
      const selectedTeacher = teachers.find(
        (teacher) => teacher.id === teacherId
      );
      if (selectedTeacher) {
        setDisplayName(selectedTeacher.fullName);
      }
    } else {
      setDisplayName("");
    }
  };

  const fetchteachers = async () => {
    try {
      const { data } = await getTeachers();
      setteachers(data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchteachers();
  }, []);

  return (
    <Layout>
      <div
        className="container mt-4 overflow-hidden"
        style={{ overflow: "hidden" }}
      >
        <div className="row text-center mb-2">
          <h3 className="h3">
            {displayName
              ? `Search Results for "${displayName}"`
              : "Search transaction of teachers"}
          </h3>
        </div>

        <form onSubmit={handleSearch}>
          <div className="row gx-0">
            {" "}
            <div className="col-12 col-md-5 pe-2">
              <select
                className="form-select"
                value={selectedTeacherId}
                onChange={handleChange}
                aria-label="Select teacher"
              >
                <option value="">Select a teacher...</option>
                {teachers?.map((teacher) => (
                  <option key={teacher?.id} value={teacher?.id}>
                    {teacher?.fullName}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-5 pe-2">
              <select
                className="form-select"
                aria-label="Select month"
                onChange={(e) => setSelectedMonth(e.target.value)}
              >
                <option value="">Select month</option>
                {months?.map((month) => (
                  <option key={month?.id} value={month.value}>
                    {month.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-2 d-flex justify-content-end align-items-end">
              <button
                type="submit"
                className="btn btn-dark w-100"
                disabled={!selectedTeacherId || !selectedMonth}
              >
                Search
              </button>
            </div>
          </div>
        </form>

        {searchParams.teacherId && searchParams.month && (
          <div className="row mt-0">
            <div className="col-12">
              <TeacherWalletSummary
                id={searchParams.teacherId}
                month={searchParams.month}
              />
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default TeacherTransactions;

const months = [
  { id: 1, name: "January", value: 1 },
  { id: 2, name: "February", value: 2 },
  { id: 3, name: "March", value: 3 },
  { id: 4, name: "April", value: 4 },
  { id: 5, name: "May", value: 5 },
  { id: 6, name: "June", value: 5 },
  { id: 7, name: "July", value: 7 },
  { id: 8, name: "August", value: 8 },
  { id: 9, name: "September", value: 9 },
  { id: 10, name: "October", value: 10 },
  { id: 11, name: "November", value: 11 },
  { id: 12, name: "December", value: 12 },
];
